import React, { useEffect } from 'react';
import PageGraphic from '../components/PageGraphic';
import imgGrpahic from '../assets/img/landing.png';
import styled from 'styled-components/macro';
import Quote from '../components/Quote';

export const Wrapper = styled.div`
  position: relative;

  & > div {
    padding: 64px 80px;
    @media screen and (max-width: 500px) {
      padding: 32px 40px;
    }
  }
`;

const Landing = () => {
  useEffect(() => {
    document.title = 'Emprouen Advisors';
  }, []);

  return (
    <Wrapper>
      <PageGraphic src={imgGrpahic} />

      <div>
        <h6>
          <b>Emprouen Advisors</b> is a premier hypergrowth, transaction and
          turnaround advisory firm. We hold real world experience with numerous
          successful engagements.
        </h6>

        <Quote
          by="Lee Dorkin"
          title="Managing Partner"
          style={{ marginTop: 48 }}
        >
          After twenty years of listening and learning from those businesses
          I’ve supported, there's a new approach required to drive long-term
          performance. We’ve built a firm, tested and proved the methods that
          sets us apart. We are here to tap in and help our clients achieve the
          success they desire.
        </Quote>
      </div>
    </Wrapper>
  );
};

export default Landing;
